export default __webpack_public_path__ + "static/media/video-call-blue-icon.fc592968.svg";